import { axios } from '@/services/axios';

const getSBCByID = (sbcId) => {
    return axios.get(`/sessionbordercontroller/${sbcId}`);
};

export default getSBCByID;
